import { call, takeLatest } from 'redux-saga/effects';
import * as api from '@api/imagingLabels';
import { actions } from './imagingLabels.slice';
import {
  AssignLabelsAction,
  ImagingLabelsFetchAction,
  UnAssignLabelsAction,
} from './imagingLabels.types';
import { Resp, dispatch } from '../helpers';
import { fetchClinicalTrialSuccess } from '../clinicalTrial/clinicalTrial.slice';
import { fetchClinicalTrialById } from '@api/clinicalTrials';
import { runToast, showErrorToast } from '@restore/tools';
import { actions as activateActions } from '../activate/activateClinicalTrialSlice';

export function* fetchImagingLabelsWorker(action: ImagingLabelsFetchAction) {
  try {
    const response: Resp<typeof api.fetchImagingLabels> = yield call(
      api.fetchImagingLabels,
      action.payload
    );
    yield dispatch(actions.fetchImagingLabelsSuccess(response.data));
  } catch (error) {
    yield dispatch(actions.fetchImagingLabelsError(error as Error));
  }
}

export function* assignLabelsWorker({ payload }: AssignLabelsAction) {
  try {
    yield call(
      api.assignImagingLabelToCt,
      payload.clinicalTrialId,
      payload.data
    );
    const clinicalTrailResponse: Resp<typeof fetchClinicalTrialById> =
      yield call(fetchClinicalTrialById, payload.clinicalTrialId);
    yield dispatch(fetchClinicalTrialSuccess(clinicalTrailResponse?.data));
    yield dispatch(actions.assignLabelsSuccess(null));
    yield call(runToast, 'success', 'Assigning Labels successfully');
    yield dispatch(
      activateActions.setErrors({ name: 'imagingLabels', errors: [] })
    );
  } catch (error) {
    yield dispatch(actions.assignLabelsFailure(null));
    yield showErrorToast(error, 'Assigning Labels failed');
  }
}
export function* unAssignLabelsWorker({ payload }: UnAssignLabelsAction) {
  try {
    yield call(
      api.unassignImagingLabelFromCt,
      payload.clinicalTrialId,
      payload.labelId
    );
    const clinicalTrailResponse: Resp<typeof fetchClinicalTrialById> =
      yield call(fetchClinicalTrialById, payload.clinicalTrialId);
    yield dispatch(fetchClinicalTrialSuccess(clinicalTrailResponse?.data));
    yield dispatch(actions.assignLabelsSuccess(null));
    yield call(runToast, 'success', 'Label successfully deleted');
  } catch (error) {
    yield dispatch(actions.assignLabelsFailure(null));
    yield showErrorToast(error, 'Delete label error');
  }
}

export function* imagingLabelsSaga() {
  yield takeLatest(actions.fetchImagingLabels.type, fetchImagingLabelsWorker);
  yield takeLatest(actions.assignLabelsRequest.type, assignLabelsWorker);
  yield takeLatest(actions.unAssignLabelsRequest.type, unAssignLabelsWorker);
}
